import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewMemberkitForm from "../../../components/apps/memberkit/NewMemberkitForm";

export default function NewMemberkit() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/memberkit`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Integração Memberkit"
                description="Criar nova integração Memberkit"
            />
            <PageBreadcrumb
                pageTitle="Nova Integração Memberkit"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewMemberkitForm
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de webhooks
                        navigate(`/apps/memberkit`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar integração Memberkit:", error);
                    }}
                />
            </div>
        </>
    );
}